module.exports = __webpack_public_path__ + "./docs/img/icon-namespace.3ed7c2476d94c78a4a2e83b3485d42a4.svg";